import { ICallComment } from 'src/call/types'

// eslint-disable-next-line
export const COMMENT_HIGHLIGHT_TYPEAHEAD_REGEXP = /^(@[^@\s]*)$|^(@[^@\s]+@(?:[^@\s.]+\.?)*[^@\s.]*)$/i
// eslint-disable-next-line
export const COMMENT_HIGHLIGHT_REGEXP_GROUPED = /@([^@\s]+@(?:[^@\s.]+\.)+[^@\s.]+)/gi
// eslint-disable-next-line
export const COMMENT_HIGHLIGHT_REGEXP = /(@[^@\s]+@(?:[^@\s.]+\.)+[^@\s.]+)/gi

export const sortComments = (a: ICallComment, b: ICallComment) => {
  // Order first by start time, then by id on tie break
  if (a.start_time < b.start_time) {
    return -1
  } else if (a.start_time > b.start_time) {
    return 1
  } else if (a.id < b.id) {
    return -1
  } else if (a.id > b.id) {
    return 1
  } else {
    return 0
  }
}
